import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../OtherEqp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import classifier from "../../images/classifier.png";
import SEOHelmet from "../../components/SEO/SEOHelmet";
import RelatedEquipments from "./RelatedEquipments";

const Classifiers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    { title: 'High Precision Classification', description: 'Ensures accurate separation of particles based on size, enhancing product quality.' },
    { title: 'Versatile Applications', description: 'Suitable for various industries including chemical, food, pharmaceutical, and mineral processing.' },
    { title: 'Energy Efficient', description: 'Operates with low power consumption, reducing operational costs.' },
    { title: 'Compact Design', description: 'Space-saving design suitable for various workshop sizes.' },
    { title: 'User-Friendly Operation', description: 'Designed for ease of use, reducing operator training time.' },
    { title: 'Durable Construction', description: 'Built with high-quality materials to withstand rigorous industrial use.' },
    { title: 'Low Maintenance', description: 'Features a simple design that requires minimal maintenance, ensuring long-term reliability.' },
    { title: 'Safety Features', description: 'Incorporates safety mechanisms to protect operators during operation.' }
  ];

  const applications = [
    'Food Processing',
    'Mineral Processing',
    'Plastic Recycling',
    'Metal Recycling',
    'Rubber Recycling',
  ];

  const specs = [
    { label: 'Classification Accuracy', value: '±0.5%' },
    { label: 'Capacity', value: 'Up to 5 Tons/Hour' },
    { label: 'Power Consumption', value: '5 kW' },
    { label: 'Machine Dimensions (L x W x H)', value: '1.8 m x 1.2 m x 1.5 m' },
    { label: 'Weight', value: '450 kg' }
  ];

  return (
    <div className="tbf-page">

      {/* ✅ SEO HELMET */}
      <SEOHelmet
        title="Classifiers Manufacturer in India"
        description="Vikah Ecotech is a leading Classifiers manufacturer in India offering high precision particle separation systems for food, mineral, plastic, and recycling industries."
        keywords="Classifiers manufacturer in India, industrial classifier machine, particle separation equipment, mineral classifier, plastic recycling classifier"
        canonical="https://vikahecotech.com/classifiers"
        pageName="Classifiers"
        product={{
          name: "Industrial Classifiers",
          description: "High precision industrial classifiers designed for accurate particle size separation across multiple industries.",
          image: "https://vikahecotech.com/logo_vk.png",
          url: "https://vikahecotech.com/classifiers",
          sku: "VK-CLS-01",
          category: "Industrial Separation Equipment",
          price: "260000"
        }}
        breadcrumb={[
          { name: "Home", url: "https://vikahecotech.com/" },
          { name: "Other Equipment", url: "https://vikahecotech.com/other-equipment" },
          { name: "Classifiers", url: "https://vikahecotech.com/classifiers" }
        ]}
      />

      {/* Header */}
      <header className="tbf-header-enhanced text-white py-5 position-relative">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start">
              <h1 className="tbf-heading display-5 fw-bold">Classifiers</h1>
              <p className="lead mt-3">
                High-performance Classifier Machines designed to separate materials based on size,
                density, and particle distribution with exceptional accuracy. Built for continuous
                operation and minimal maintenance, these classifiers enhance product purity,
                streamline processing, and boost overall efficiency in rubber recycling plants,
                industrial manufacturing units, and material processing industries.
              </p>
            </Col>
            <Col md={6} className="text-center mt-4 mt-md-0">
              <img src={classifier} alt="Classifier Machine" className="stripcutter-image img-fluid" />
            </Col>
          </Row>
        </Container>
      </header>

      {/* Technical Overview */}
      <div className="specs-box shadow">
        <h5 className="fw-bold mb-3">Technical Overview</h5>
        <ul className="list-unstyled mb-0">
          {specs.map((item, idx) => (
            <li key={idx}><strong>{item.label}:</strong> {item.value}</li>
          ))}
        </ul>
      </div>

      {/* Features */}
      <section className="tbf-section tbf-features">
        <Container>
          <h2 className="section-title text-center mb-5">Key Features</h2>
          <div className="feature-grid">
            {features.map((feature, idx) => (
              <div key={idx} className="feature-card shadow-sm">
                <div className="feature-icon">
                  <i className="bi bi-check-circle-fill"></i>
                </div>
                <h5 className="feature-title">{feature.title}</h5>
                <p className="feature-desc">{feature.description}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Applications */}
      <section className="tbf-section tbf-applications">
        <Container>
          <h2 className="section-title text-center mb-5">Applications</h2>
          <div className="applications-grid">
            {applications.map((app, idx) => (
              <div key={idx} className="application-card shadow-sm">
                <i className="bi bi-box-seam"></i>
                <span>{app}</span>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <div className="tbf-intro container text-center my-4">
        <p className="mt-3 fw-semibold text-center">
          The Classifier system forms an essential component of our industrial processing line under the{" "}
          <a href="/other-equipment" className="fw-bold text-decoration-none">
            Screening & Separation Equipment
          </a>{" "}
          category, ensuring precise material separation to support smooth downstream operations.
        </p>
      </div>

      {/* RelatedEquipments */}
      <RelatedEquipments current="/classifiers" />

      {/* Contact */}
      <section className="tbf-contact-section text-white text-center py-5 m-5">
        <Container>
          <h4 className="fw-bold mb-3">Get in Touch</h4>
          <p className="mb-0">
            For more information about our Classifiers or to request a quote, please contact us at{" "}
            <a href="mailto:info@vikahecotech.com" className="fw-bold text-white">
              info@vikahecotech.com
            </a>.
          </p>
        </Container>
      </section>

    </div>
  );
};

export default Classifiers;
